<template>
  <AdminLogin/>
</template>

<script>
import AdminLogin from "@/components/auth/AdminLogin.vue";

export default {
  components: {
    AdminLogin
  }
};
</script>

<style>
</style>
